import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import * as UserDataConfig from '../../config/user-data.config';
import { FormValidationsService, QuoteDataCaptureService, SERVICE_END_POINT, AnalyticsService, AuthService } from 'src/app/shared';

import { AppState } from '../../../../store/state/app.state';
import { Observable, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { DependantDetails } from '../../../../model/ngrx/dependant-details.model';
import { PersonalDetails } from '../../../../model/ngrx/personal-details.model';
import * as DepDetailsActions from '../../../../store/actions/dependant-details.actions';
import * as RefNumberActions from '../../../../store/actions/reference-number.actions';
import { RefNo } from '../../../../model/ngrx/reference-number.model';
import { AlertModal } from 'src/app/model/alert';
import { UtilService } from '../../../../shared';
import { CardRefresh } from 'src/app/model/ngrx/card-refresh.model';
import * as CardRefreshActions from '../../../../store/actions/card-refresh.actions';
import { MEDICAL_UW_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import { HealthService } from 'src/app/core/cms/health/health.service';
import { SyncService } from 'src/app/pages/medical-underwriting/services/sync.service';
import { UnderWritingData } from 'src/app/pages/medical-underwriting/model';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { ConfigLoaderService } from 'src/app/shared/services/api-services/configLoader.service';

@Component({
  selector: 'app-dependant-details',
  templateUrl: './dependant-details.component.html',
  styleUrls: ['./dependant-details.component.scss']
})
export class DependantDetailsComponent implements OnInit, OnDestroy {
  dependantDetailForm: UntypedFormGroup;
  contentData;
  dependantForm: DependantDetails;
  dependantFormEdit: DependantDetails;
  personalForm: PersonalDetails;
  relationshipOptions;
  tooltipModal;
  public tooltipModalConfig: AlertModal;
  personalDetailsStore: Observable<PersonalDetails[]>;
  dependantDetailsStore: Observable<DependantDetails[]>;
  referenceNumberStore: Observable<RefNo[]>;
  private responseQuoteCalculation: any[];
  private responseQuoteCalculationStore: Observable<any[]>;
  referenceNumber: RefNo;
  relationshipData;
  displayTooltipAlert = false;
  editMode: boolean;
  displayAlert: boolean = false;
  displayContent: boolean = false;
  public userInputDetail = UserDataConfig.ElementsConfig;
  // tslint:disable-next-line:max-line-length
  public ageValidatorFlag: boolean = false;
  public depChangeValidatorFlag: boolean = false;
  public dependentMinAge: string;
  public depSelected: string;
  // tslint:disable-next-line:max-line-length
  public alertCardRefreshModalConfig: AlertModal = new AlertModal('alert', ' You have entered new information that may impact your quote', '', 'Continue', 'Discard changes', '');
  public alertModalConfig: AlertModal;
  // tslint:disable-next-line:max-line-length
  public ageAlertModalConfig: AlertModal = new AlertModal('alert', 'You\'re outside the age range we typically deal with', '', 'Proceed', '', '');
  public depChangeAlertModalConfig: AlertModal;
  QuoteAffectingValues = this.userInputDetail.QuoteAffectingValues;
  private subscriptn: Subscription;
  private subscripBeforeLogin: Subscription;
  private subscripFormValueChange: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  private formchangeSubs: Subscription;
  cardRefreshStore: Observable<CardRefresh[]>;
  cardStoreVal: boolean;
  cardRefresh: boolean;
  showModalForCardRefresh: boolean = false;
  dobFlag:boolean = false;
  genderFlag: boolean = false;
  relationshipFlag: boolean = false;
  quoteRefNo: string;
  private CMSData;
  private rangeValidationData: any;
  private lifeStyleFromStoreObsSubscription: Subscription;
  private lifeStylePayloadFromStoreObj: UnderWritingData;
  screenName;
  isDateInputRequired: boolean=false;
  constructor(private fb: UntypedFormBuilder, private router: Router, 
              private activatedRoute: ActivatedRoute,
              private store: Store<AppState>, private quoteDatacaptureService: QuoteDataCaptureService,
              private utilService: UtilService, private healthService: HealthService,
              private syncService: SyncService,
              public el: ElementRef,
              private analyticsService: AnalyticsService, private authService: AuthService,
             private configLoaderService: ConfigLoaderService) {

    this.contentData = this.activatedRoute.snapshot.data.contentData;
    this.dependentMinAge = this.contentData.dependantDetail.minAge;
    this.dependantDetailsStore = store.select(STORE_VAL.dependant_details);
    this.personalDetailsStore = store.select(STORE_VAL.personal_details);
    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.responseQuoteCalculationStore = this.store.select(STORE_VAL.quote_calculation);
    this.cardRefreshStore = store.select(STORE_VAL.card_Refresh);
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    // console.log('personal-store', this.dependantDetailsStore);
    this.dependantDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        this.dependantForm = val[0];
      } else if (this.dependantDetailForm && !this.quoteDatacaptureService.checkIfObjEmpty(val)) {
        this.dependantDetailForm.reset();
      }
    });
    this.personalDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        this.personalForm = val[0];
      }
    });
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        this.quoteRefNo = this.referenceNumber?.quoteReferenceNumber;

        if (this.referenceNumber && this.referenceNumber.editMode) {
          this.editMode = true;
          this.userInputDetail['buttonConfig']['label'] = 'Done';
          this.userInputDetail['buttonConfig']['name'] = 'Done';
          this.dependantFormEdit = JSON.parse(JSON.stringify(this.dependantForm));
        } else {
          this.editMode = false;
        }
      }
    });

    this.responseQuoteCalculationStore = this.store.select(STORE_VAL.quote_calculation);
    this.responseQuoteCalculationStore.subscribe((val) => {
      if (val.length > 0) {
        this.responseQuoteCalculation = val[0];
      } else if (val.length === 0) {
        this.responseQuoteCalculation = val;
      }
    });

    this.cardRefreshStore.subscribe((val) => {
      if (val) {
        this.cardStoreVal = val[0]?.['setCardRefresh'];
        // console.log("card Refresh store value",this.cardStoreVal);
      }
    });

    this.lifeStyleFromStoreObsSubscription = this.store.select(STORE_VAL.lifestyle).subscribe(res => {
      if (res.length > 0) {
        this.lifeStylePayloadFromStoreObj = res[0];
      }
    });

    this.cardRefresh = this.quoteDatacaptureService.isCardCreatedforRefresh(this.quoteRefNo);
  }

  ngOnInit() {
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.isDateInputRequired = this.configLoaderService.configuration.isDateInputRequired;

    this.GetCMSDataServiceMapper();
    // this.alertModalConfig.setContent(this.contentData.generalConstants.quoteChangeWarning);
    this.ageAlertModalConfig.setContent(this.contentData.generalConstants.ageValidationWarning);
    // this.depChangeAlertModalConfig = this.contentData.dependantDetail.depChangeAlertModalConfig;
    this.alertCardRefreshModalConfig.setContent(this.contentData.generalConstants.cardRefreshWarning);
    this.getLifestyleRange();
    this.userFormData();
    this.relationshipView();
    this.disableRadioButtons();
    // this.QuoteAffectingValues = {
    //   dependantDetail: [
    //     'gender',
    //     'dateOfBirth',
    //     'relationship'
    //   ]
    // };
    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    this.subscripLogout = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();

    });
    let formChanged;
    this.formchangeSubs = this.dependantDetailForm.get('dateOfBirth').valueChanges
      .pipe(
      filter(() => this.dependantDetailForm.get('dateOfBirth').valid)
      )
      .subscribe(res => {
        if (this.dependantForm && res !== this.dependantForm.dateOfBirth) {
          this.dobFlag = true;
          formChanged = true;
          this.showNext(formChanged);
          this.showRefreshModal();
        }
      });
    this.formchangeSubs = this.dependantDetailForm.get('gender').valueChanges
      .pipe(
      filter(() => this.dependantDetailForm.get('gender').valid)
      )
      .subscribe(res => {
        if (this.dependantForm && res !== this.dependantForm.gender) {
          this.genderFlag = true;
          formChanged = true;
          this.showNext(formChanged);
          this.showRefreshModal();
        }
      });
    this.formchangeSubs = this.dependantDetailForm.get('relationship').valueChanges
      .pipe(
      filter(() => this.dependantDetailForm.get('relationship').valid)
      )
      .subscribe(res => {
        if (this.dependantForm && res !== this.dependantForm.relationship) {
          this.relationshipFlag = true;
          formChanged = true;
          this.showNext(formChanged);
          this.showRefreshModal();
        }
      });
    this.formchangeSubs = this.dependantDetailForm.get('dependantQuestion').valueChanges
      .pipe(
      filter(() => this.dependantDetailForm.valid)
      )
      .subscribe(res => {
        if (this.dependantForm && res !== this.dependantForm.dependantQuestion) {
          formChanged = true;
          this.showNext(formChanged);
        }
      });
    const obj = new ParentFormAndElmModel(this.dependantDetailForm, this.el, null, null);
    this.utilService.setParentFormToValidate(obj);

  }
  showRefreshModal() {
    //  if(this.cardRefresh && this.cardStoreVal && this.showModalForCardRefresh===false){
    if (this.cardRefresh && this.cardStoreVal && this.showModalForCardRefresh === false) {
      this.showModalForCardRefresh = true;
    }
  }
  closeCardRefreshModal() {
    this. resetForm();
    // passing false value as parameter when the user discards the current changes
    this.showNext(false);
  }
  alertSecondaryCardRefreshBtnClick(){
    this. resetForm();
    // passing false value as parameter when the user discards the current changes
    this.showNext(false);
     // this.displayAlert = false;
  }
  resetForm() {
    this.dependantDetailForm.get('dateOfBirth').setValue(this.dependantForm.dateOfBirth);
    this.dependantDetailForm.get('gender').setValue(this.dependantForm.gender);
    this.dependantDetailForm.get('relationship').setValue(this.dependantForm.relationship);
    this.showModalForCardRefresh = false;
  }

  alertPrimaryBtnClickinModal() {
    this.quoteDatacaptureService.postRefreshCard().subscribe(res => {
    });
    this.store.dispatch(new CardRefreshActions.RemoveCardRefreshval(0));
    this.store.dispatch(new CardRefreshActions.AddCardRefreshval({ setCardRefresh: false }));
    this.showModalForCardRefresh = false;

  }
  userFormData = () => {
    if (this.dependantForm) {
      this.userInputDetail.dependantDetailDob.value = this.dependantForm.dateOfBirth;
      this.dependantDetailForm = this.fb.group({
        dateOfBirth: [this.dependantForm.dateOfBirth],
        gender: [this.dependantForm.gender !== "" ? this.dependantForm.gender : null],
        relationship: [this.dependantForm.relationship],
        dependantQuestion: [this.dependantForm.dependantQuestion]
      });
      if (this.dependantForm.dependantQuestion === 'Y') {
        this.displayContent = true;
      }
    } else {
      this.userInputDetail.dependantDetailDob.value = '';
      this.dependantDetailForm = this.fb.group({
        dateOfBirth: [''],
        gender: [null],
        relationship: [null],
        dependantQuestion: [null, Validators.required]
      });
    }
  }
  showNext(formChanged) {
    /* Defect# 3345 - Regression - Playback screen - Two pop up appears when clciked on Review
      and also if user clicks on discard chnages then button should be as Done instead of Next */
    /* label name is changed to 'Next' only when formvalues are changed */
    this.userInputDetail['buttonConfig']['label'] = formChanged === false ? 'Done' : 'Next';
    this.userInputDetail['buttonConfig']['name'] = formChanged === false ? 'Done' : 'Next';
  }
  ngOnDestroy() {

    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    if (this.formchangeSubs) {
      this.formchangeSubs.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
  }
  createQuestionarray(): any {
    const questionArray = [];
    if (this.dependantDetailForm.controls.dependantQuestion.value) {
      questionArray.push({
        questionCode: 'dependantQuestion',
        // question: this.userInputDetail.radioButtonDependantConfig.questionStatement,
        questionType: this.userInputDetail.radioButtonDependantConfig.questionType,
        answer: this.dependantDetailForm.controls.dependantQuestion.value
      });
    }
    return questionArray;
  }
  saveAfterLogin() {
    if (this.dependantDetailForm.get('dependantQuestion').value === 'N') {
      this.setNullValues();
    }
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully());
  }
  saveAfterLogout() {
    if (this.dependantDetailForm.get('dependantQuestion').value === 'N') {
      this.setNullValues();
    }
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveProgress() {
    if (this.dependantDetailForm.get('dependantQuestion').value === 'N') {
      this.setNullValues();
    }
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
  }
  saveFormValues() {
    this.store.dispatch(new DepDetailsActions.RemoveDependantDetails(0));
    this.store.dispatch(new DepDetailsActions.AddDependantDetails({
      dateOfBirth: this.dependantDetailForm.controls.dateOfBirth.value ? this.dependantDetailForm.controls.dateOfBirth.value : null,
      gender: this.dependantDetailForm.controls.gender.value ? this.dependantDetailForm.controls.gender.value : null,
      relationship: this.dependantDetailForm.controls.relationship.value ? this.dependantDetailForm.controls.relationship.value : null,
      // tslint:disable-next-line:max-line-length
      dependantQuestion: this.dependantDetailForm.controls.dependantQuestion.value ? this.dependantDetailForm.controls.dependantQuestion.value : null,
      riskAndStaticQuestion: this.createQuestionarray()
    }));
  }
  checkStatus = () => {
    return this.dependantDetailForm.invalid;
  }
  showChangeAlert = () => {
    // if (this.dependantDetailForm.valid) {
    let formchanged = false;
    let isrefresh = false;
    if (this.editMode) {
      for (let val of this.QuoteAffectingValues.dependantDetail) {
        if (this.dependantDetailForm.controls[val].value !== this.dependantFormEdit[val]) {
          this.dependantFormEdit[val] = this.dependantDetailForm.controls[val].value;
          formchanged = true;
          isrefresh = true;
          break;
        }
      }
      if (formchanged && !isrefresh) {
        this.displayAlert = true;
      } else {
      }
    }
    // }
  }
  setNullValues() {
    // if (this.annuitantDetailForm.get('ukaddressIndicator').value === 'N') {
    this.dependantDetailForm.get('dateOfBirth').setValue(null);
    this.dependantDetailForm.get('gender').setValue(null);
    this.dependantDetailForm.get('relationship').setValue(null);
    // }
  }
  gotoNext = () => {
    // let formchanged = false;
    if (this.dependantDetailForm.get('dependantQuestion').value === 'N') {
      this.setNullValues();
    }
    if (this.dependantDetailForm.valid) {
      if (this.editMode || this.userInputDetail.buttonConfig.name.toUpperCase() !== 'NEXT') {
        this.referenceNumber = {...this.referenceNumber, editMode: false};
        this.store.dispatch(new RefNumberActions.RemoveReferenceNumber(0));
        this.store.dispatch(new RefNumberActions.AddReferenceNumber(this.referenceNumber));
        this.editMode = false;
        this.formChangedData();
      } else { 
        // this.annuitantService.postAnnuitantDetail(this.dependantDetailForm.value);
        this.saveFormValues();
        this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
          // tslint:disable-next-line:max-line-length
          if (this.dependantDetailForm.controls['dependantQuestion'].valid && this.dependantDetailForm.controls['dependantQuestion'].value === 'Y' || this.lifeStylePayloadFromStoreObj.dependentMedicalConditions.length > 0) {
            this.router.navigate([MEDICAL_UW_URL.dependant.dependantLifestyle]);
          } else {
            this.router.navigate(['/quote/your-product-options']);
          }
        });
      }
      // tslint:disable-next-line:max-line-length
    } else if (this.dependantDetailForm.controls['dependantQuestion'].valid && this.dependantDetailForm.controls['dependantQuestion'].value === 'N') {
      if (this.editMode) {
        this.formChangedData();
      } else {
        this.saveFormValues();
        this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
          this.router.navigate(['/quote/your-product-options']);
        });
      }
    } else {
      FormValidationsService.validateAllFormFields(this.dependantDetailForm, this.analyticsService);
    }
  }
  relationshipView = () => {
    let selectedValue = this.dependantDetailForm.controls['relationship'].value;
    this.relationshipOptions = JSON.parse(JSON.stringify(this.userInputDetail.relationshipConfig));
    if (this.userInputDetail.relationshipConfig && this.personalForm && this.personalForm.maritalStatus === 'S' ||
      // tslint:disable-next-line:max-line-length
      (this.personalForm.maritalStatus === 'CH') || (this.personalForm.maritalStatus === 'D') || (this.personalForm.maritalStatus === 'W')) {
      this.relationshipData = this.userInputDetail.relationshipConfig.options.filter(item => item.code === 'F');
      this.relationshipOptions.options = this.relationshipData;
    } else if (this.userInputDetail.relationshipConfig && this.personalForm && this.personalForm.maritalStatus === 'M') {
      this.relationshipData = this.userInputDetail.relationshipConfig.options.filter(item => item.code === 'S');
      this.relationshipOptions.options = this.relationshipData;
    } else if (this.userInputDetail.relationshipConfig && this.personalForm && this.personalForm.maritalStatus === 'C') {
      this.relationshipData = this.userInputDetail.relationshipConfig.options.filter(item => item.code === 'R');
      this.relationshipOptions.options = this.relationshipData;
    } else if (this.userInputDetail.relationshipConfig && this.personalForm && this.personalForm.maritalStatus === 'SE') {
      this.relationshipData = this.userInputDetail.relationshipConfig.options.filter(item => item.code !== 'F');
      this.relationshipOptions.options = this.relationshipData;
    } else if (this.userInputDetail.relationshipConfig && this.personalForm && this.personalForm.maritalStatus === 'CP') {
      this.relationshipData = this.userInputDetail.relationshipConfig.options.filter(item => item.code === 'R');
      this.relationshipOptions.options = this.relationshipData;
    }
    // else {
    //   this.relationshipData = this.userInputDetail.relationshipConfig.options;
    // }
    if (this.dependantForm) {
      const relationshipSelected = this.relationshipOptions.options.filter((relationshipOption) => {
        return relationshipOption.code === this.dependantForm.relationship;
      });
      this.dependantDetailForm.get('relationship').setValue(relationshipSelected.length > 0 ? this.dependantForm.relationship : null);
    } else {
      this.dependantDetailForm.get('relationship').setValue(null);
    }
  }
  alertPrimaryBtnClick() {
    this.closeModal();
  }

  alertSecondaryBtnClick() {
    this.closeModal();
  }
  closeModal() {
    this.displayAlert = false;
    this.displayTooltipAlert = false;
  }

  alertAgePrimaryBtnClick() {
    this.closeAgeModal();
  }
  alertAgeSecondaryBtnClick() {
    this.closeAgeModal();
  }
  closeAgeModal() {
    this.ageValidatorFlag = false;
  }

  ddlChange = () => {
    this.showChangeAlert();
  }
  checkDataChange = (flagArray) => {
    if (flagArray[1] === true) {
      this.ageValidatorFlag = true;
    }
    this.showChangeAlert();
  }
  OnBackClick() {
    if (this.dependantDetailForm.get('dependantQuestion').value === 'N') {
      this.setNullValues();
    }
    this.saveFormValues();
  }
  getToggleValue = (ev) => {
    this.depSelected = ev;
    if (this.responseQuoteCalculation &&
      (this.dependantForm && this.dependantForm.dependantQuestion !== ev) &&
      this.responseQuoteCalculation['benefitVariants'] &&
      this.responseQuoteCalculation['benefitVariants'].length > 0) {
      this.showNext(true);
      this.showRefreshModal();
      this.depChangeValidatorFlag = true;
    } else {
      this.changeDependant(ev);
    }
  }
  depChangePrimaryBtnClick = () => {  
    this.depChangeValidatorFlag = false;
    this.changeDependant(this.depSelected);
  }
  closeDepChangeModal = () => {
    if (this.depSelected && this.depSelected === 'Y') {
      this.dependantDetailForm.controls.dependantQuestion.setValue('N');
    } else if (this.depSelected && this.depSelected === 'N') {
      this.dependantDetailForm.controls.dependantQuestion.setValue('Y');
    }
    this.utilService.refreshToggleButton();
    this.depChangeValidatorFlag = false;
  }
  changeDependant = (ev) => {
    if (ev === 'Y' || this.lifeStylePayloadFromStoreObj.dependentMedicalConditions.length > 0) {
      this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Add dependent', pageID: this.getCurrentScreenURL() });
      this.displayContent = true;
      const value = { selected: true };
      this.utilService.refreshBreadcrumb(value);
    } else {
      this.displayContent = false;
      //this.setNullValues();
      const value = { selected: false };
      this.utilService.refreshBreadcrumb(value);
    }
  }

  disableRadioButtons() {
    if (this.lifeStylePayloadFromStoreObj.dependentMedicalConditions.length > 0) {
      this.userInputDetail.radioButtonDependantConfig.disabled = true;
    } else {
      this.userInputDetail.radioButtonDependantConfig.disabled = false;
    }
  }

  formChangedData = () => {
    let formchanged = false;
    for (let val of this.QuoteAffectingValues.dependantDetail) {
      if (this.dependantDetailForm.controls[val].value !== this.dependantForm[val]) {
        formchanged = true;
        break;
      }
    }
    if (formchanged) {
      this.saveFormValues();
      this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
        if (this.dependantDetailForm.controls['dependantQuestion'].valid && this.dependantDetailForm.controls['dependantQuestion'].value === 'Y') {
          this.router.navigate([MEDICAL_UW_URL.dependant.dependantLifestyle]);
        } else {
          this.router.navigate(['/quote/your-product-options'], { replaceUrl: true });
        }
      });
    } else {

      this.router.navigate(['/quote/please-confirm-your-details'], { replaceUrl: true });
    }
  }


  getLifestyleRange() {
    this.healthService.getRangeValidation()
      .subscribe(res => {
        this.rangeValidationData = res.values;
        this.syncService.setRangeValidationJson(this.rangeValidationData);
      });
  }
  
  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    //console.log('changed value = ', this.contentData);
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourDependant;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.dependantDetail.header = this.CMSData.string_DependantTitle;
        this.contentData.dependantDetail.introduction  = this.CMSData.string_DependantSubtitle;
        this.contentData.dependantDetail.introduction_sub  = this.CMSData.string_DependantChosenSubtitle;
        this.userInputDetail.radioButtonDependantConfig.questionStatement = this.CMSData.string_DependantQuestion;
        this.userInputDetail.dependantDetailTitleInformation.content = this.CMSData.string_DependantChosenSubtitleInformationWording;
        this.userInputDetail.dependantDetailDob.errorMessage = this.CMSData.commonBlock.string_DobErrorMessageWording;
        this.userInputDetail.dependantDetailDob.errorMessageInvalidDate = this.CMSData.commonBlock.string_ValidDobErrorMessageWording;
       // this.userInputDetail.dependantDetailDob.errorMessageInvalidFormat = this.CMSData.string_DependantDobErrorMessage_2;
        this.userInputDetail.depandantDetailGenderConfig.errorMessage = this.CMSData.commonBlock.string_GenderErrorMessage;
        this.userInputDetail.relationshipConfig.errorMessage = this.CMSData.commonBlock.string_DependantRelationshipErrorMessage;

        this.relationshipOptions.errorMessage = this.CMSData.commonBlock.string_DependantRelationshipErrorMessage;
        this.userInputDetail['buttonConfig'].name = this.CMSData.commonBlock.string_NextCTALabel;
        this.alertModalConfig = new AlertModal('alert', this.CMSData.commonBlock.string_DependantRemovedPopUpTitle, this.CMSData.commonBlock.string_DependantRemovedPopUpText, this.CMSData.commonBlock.string_OKCTALabel, '', 'Don’t show this message again');
        this.depChangeAlertModalConfig = new AlertModal('alert', this.CMSData.commonBlock.string_DependantRemovedPopUpTitle, this.CMSData.commonBlock.string_DependantRemovedPopUpText, this.CMSData.commonBlock.string_OKCTALabel, '', '');
      }
    });
  }
  /** End of code block for CMS */

  /** For web tracking */
  getCurrentScreenURL() {
    this.screenName = this.utilService.getScreenNameFromURL(this.router.url);

    return this.screenName;
  }
  qualifyingDependentInfoReceiver(val) {
    this.analyticsService.eventTrack({ type: 'Question', name: 'Add qualifying dependant', pageID: this.getCurrentScreenURL() });
  }

  displayTooltipMessage(inputDetail){
    this.tooltipModal.content = inputDetail.infoIconData.content;
    this.displayTooltipAlert = true;
  }

  displayTooltipMessageForDependentAnnuity(inputDetail){
    this.tooltipModal.content = inputDetail.content;
    this.displayTooltipAlert = true;
  } 

  alertTooltipPrimaryBtnClick() {
    this.displayTooltipAlert = false;
  }
}
